import { Behavior } from '../Behavior';
import { TaskStatus } from '../TaskStatus';
/**
 * 作为子项运行整个BehaviorTree并返回成功
 */
export class BehaviorTreeReference extends Behavior {
    constructor(tree) {
        super();
        this._childTree = tree;
    }
    update(_context) {
        this._childTree.tick();
        return TaskStatus.Success;
    }
}
//# sourceMappingURL=BehaviorTreeReference.js.map